import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import DownIcon from "assets/icons/arrow-down.svg?react";

const Accordion: FC<Props> = ({ children, label, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  // rozwinięta na start: „auto” do pierwszego pomiaru — bez animacji otwierania przy wejściu na ekran
  const [height, setHeight] = useState(defaultOpen ? "auto" : "0px");
  const contentRef = useRef<HTMLDivElement>(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  }, [isOpen, children]);

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.target !== event.currentTarget) return;

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleAccordion();
    }
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.card}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onClick={toggleAccordion}
        onKeyDown={onKeyDown}
      >
        <div className={styles.label}>{label}</div>
        <div className={styles.icon}>
          <DownIcon className={`${styles.ico} ${isOpen && styles.reverse}`} />
        </div>
      </div>
      <div ref={contentRef} className={styles.content} style={{ height }}>
        <div className={styles.inner}>{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
